import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Icon } from './base-ui'
import { LabelSemiBoldMedium } from './base-ui/FontsV2'

export default function ExVatInfo() {
  const { t } = useTranslation()
  return (
    <ExVatWrapper>
      <Icon style={{ position: 'relative', top: '3px' }} name="notice-circle-2" />
      <LabelSemiBoldMedium color="infoDark">{t('exVatInfoText')}</LabelSemiBoldMedium>
    </ExVatWrapper>
  )
}

export const WrapperWithExVatInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.horizontalSpacingS};
`

const ExVatWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.horizontalSpacingXS};
  color: ${({ theme }) => theme.colors.infoDark};
`
